//
//
//
//
//
//
//
//
//
//
//
//
//

import { convertMSToYMD, formatConfiguredTime } from '../../components/helpers.js'
import Table from '../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    toolKey: {
      type: String,
      required: true
    },
    stockKey: {
      type: String,
      default: ''
    },
    stockId: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ''
    },
    complex: {
      type: Boolean,
      default: false
    },
    correction: {
      type: Boolean,
      default: null
    }
  },
  data: function () {
    return {
      filterFormId: 'toolParty',
      columns: this.prepareColumns([
        {
          name: 'issueN',
          label: '№',
          defaultWidth: 50,
          sortable: true
        },
        {
          name: 'partyName',
          label: 'Наименование партии',
          alwaysActive: true,
          sortable: true
        },
        {
          name: 'guid',
          label: 'Идентификатор партии',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Единицы измерения',
          field: row => row.unit || this.unit,
          sortable: true
        },
        {
          name: 'amount',
          label: 'Количество',
          sortable: true,
          correction: false
        },
        {
          name: 'shortfall',
          label: 'Недостача',
          sortable: true,
          correction: true
        },
        {
          name: 'excess',
          label: 'Излишек',
          sortable: true,
          correction: true
        },
        {
          name: 'issueDate',
          label: 'Дата перемещения',
          format: val => formatConfiguredTime(val, { year: true, month: true, date: true }),
          sortable: true
        },
        {
          name: 'storagePeriod',
          label: 'Срок хранения на данном складе',
          labelTable: 'Срок хранения<br/>на данном складе',
          format: val => `${convertMSToYMD(val * 24 * 60 * 60 * 1000)} (${val} д.)`,
          sortable: true
        },
        {
          name: 'startUse',
          label: 'Дата передачи в эксплуатацию',
          labelTable: 'Дата передачи<br/>в эксплуатацию',
          format: val => formatConfiguredTime(val, { year: true, month: true, date: true }),
          sortable: true
        },
        {
          name: 'servicePeriod',
          label: 'Срок эксплуатации',
          format: val => `${convertMSToYMD(val * 24 * 60 * 60 * 1000)} (${val} д.)`,
          sortable: true
        },
        {
          name: 'sN',
          label: 'Серийный номер',
          sortable: true
        },
        {
          name: 'invN',
          label: 'Инвентарный номер',
          sortable: true
        }
      ])
    }
  },
  computed: {
    visibleColumns: function () {
      let columns = this.columns || []
      if (this.correction != null) {
        if (this.correction) {
          columns = columns.filter(column => column.correction !== false)
        } else {
          columns = columns.filter(column => column.correction !== true)
        }
      }
      return columns.map(column => column.name)
    }
  },
  methods: {
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
      }
      return columns
    }
  }
}
